<td class="value-cell">{{index}}</td>
<td class="value-cell" title="{{event.Id}}">{{event.Id}}</td>
<td class="value-cell" title="{{event.eventTypeStr}}">{{event.eventTypeStr}}</td>
<td class="value-cell" title="{{processId}}" style="text-decoration: underline;"><a class="process-link"
        href="/instances/task/{{processId}}?state_env={{stateEnv}}">{{processId}}</a></td>
<td class="value-cell" title="{{taskTypeStr}}">{{taskTypeStr}}</td>
<td class="value-cell" title="{{userName}}">{{userName}}</td>
<td class="value-cell" title="{{event.createdAtStr}}">{{event.createdAtStr}}</td>
